export const DEFAULT_APPEARANCE = 'normal';